import type { Point } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import { readonlyArray } from 'fp-ts';
import { pipe } from 'fp-ts/lib/function';
import { sum } from 'utils/number/sum';

export const getPointAverage = (points: readonly Point[]): Point => ({
  x: pipe(points, readonlyArray.map(prop('x')), sum) / points.length,
  y: pipe(points, readonlyArray.map(prop('y')), sum) / points.length,
});
